import { render, staticRenderFns } from "./patentdetaliy.vue?vue&type=template&id=4b1a8277&scoped=true&"
import script from "./patentdetaliy.vue?vue&type=script&lang=js&"
export * from "./patentdetaliy.vue?vue&type=script&lang=js&"
import style0 from "./patentdetaliy.vue?vue&type=style&index=0&id=4b1a8277&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1a8277",
  null
  
)

export default component.exports